<template>
  <div class="data-sub">
    <span class="title">数据报送</span>
    <div class="data-sub-body">
      <el-date-picker
        size="small"
        class="date-select"
        v-model="searchParams.date"
        align="right"
        type="month"
        placeholder="选择日期"
        value-format="yyyy-MM"
        :picker-options="pickerOptions"
        @change="getList()"
      >
      </el-date-picker>
      <el-button style="margin-left: 10px" size="mini" @click="downloadTemp()"
        >下载模板<i class="el-icon-download el-icon--right"></i
      ></el-button>

      <el-button size="mini" @click="$refs.uploadFile.visible = true"
        >上传报送数据<i class="el-icon-upload el-icon--right"></i
      ></el-button>

      <el-table
        size="small"
        height="calc(100% - 120px)"
        :header-cell-style="{
          background: '#f5f5f5',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column align="center" label="序号">
          <template scope="scope">
            <span>{{
              (pagination.current - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="generateDate" label="日期">
        </el-table-column>
        <el-table-column align="center" prop="company.name" label="产废单位">
        </el-table-column>
        <el-table-column
          align="center"
          prop="company.uniformSocialCreditCode"
          label="统一社会信用代码"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWasterList.name"
          label="危废名称"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWasterList.type"
          label="危险废物类别"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="dangerWasterList.code"
          label="危险废物代码"
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="monthDisPos"
          label="本月处置量（吨）"
        >
          <template slot-scope="{ row }">
            <span v-if="!row.isEdit">{{ row.monthDisPos }}</span>
            <el-input
              v-else
              pattern="[0-9]*(\.[0-9]+)?"
              oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g,'$1')"
              v-model="row.monthDisPos"
              @focus="handleFocus"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              v-if="!row.isEdit"
              type="primary"
              icon="el-icon-edit-outline"
              @click="changeIsEdit(row)"
              >编辑</el-button
            >
            <div v-else>
              <el-button
                size="mini"
                type="success"
                icon="el-icon-check"
                @click="modifyRow(row)"
              >
                保存</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <uploadFile
        :url="$api.dangerWasterDatas.importHandleDangerWasterDatas"
        @getData="getList()"
        ref="uploadFile"
      ></uploadFile>
      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
      <!-- <a-table bordered :resizeable="true" :rowKey="(record) => record.id" :pagination="pagination" :columns="columns"
        :picker-options="pickerOptions" :data-source="dataSource" @showSizeChange="onPage" @change="({ current, pageSize }) => {
          onPage(current, pageSize);
        }
          " size="small" :scroll="tableHeight">
        <div slot="actions" slot-scope="text, record">
          <el-button type="text" style="color: #f56c6c" size="mini">删除</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" size="mini">修改</el-button>
        </div>
      </a-table> -->
    </div>
  </div>
</template>

<script>
import uploadFile from "@/components/uploadFile";

import { paginations } from "@/../utils/public";

export default {
  components: { uploadFile },
  data() {
    return {
      dataSource: [],
      searchParams: {
        date: this.$dayjs().format("YYYY-MM"),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableHeight: { x: "100%", y: 500 },
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
        showTotal: (total) => `一共${total}条记录 `,
      },
    };
  },
  computed: {},
  methods: {
    //点击下载
    downloadTemp() {
      var a = document.createElement("a"); // 创建一个<a></a>标签
      a.href = "/vue_template/处置端数据报送模板.xlsx"; //重点（如测试发现下载文件不存在/找不到，检查路径）
      a.download = "处置端数据报送模板.xlsx"; // 设置下载文件文件名
      a.style.display = "none"; // 隐藏a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    changeIsEdit(row) {
      if (!row.isEdit) this.$set(row, "isEdit", true);
      else row.isEdit = false;
    },
    handleFocus(event) {
      event.target.select();
    },
    getList() {
      const parames = {
        date: this.searchParams.date,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      let url = this.$api.dangerWasterDatas.getHandleDangerWasterDatas;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { data, total } = res.data.data;

          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    modifyRow(row) {
      if (!row.monthDisPos && row.monthDisPos !== 0) {
        this.$message({
          message: "本月处置量不能为空",
          type: "error",
        });
      }
      const url = `${this.$api.dangerWasterDatas.modifyHandleRow}/${row.id}?monthDisPos=${row.monthDisPos}`;
      this.$axios
        .put(url)
        .then((res) => {
          if (res.data.code === 0) {
            row.isEdit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.data-sub {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .data-sub-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }
}
</style> 